import { Modifier } from '@dnd-kit/core'

const getTransformNew: Modifier = ({ transform, activatorEvent }) => {
	if (!(activatorEvent instanceof PointerEvent)) {
		return transform
	}
	const y = Math.abs(transform.x)
	const x = activatorEvent.offsetX + (transform.x < 0 ? transform.x : 0)
	return { ...transform, y, x }
}

const getTransformHorizontal: Modifier = ({
	active,
	containerNodeRect,
	draggingNodeRect,
	transform,
}) => {
	if (!active?.data.current) return transform
	if (!containerNodeRect || !draggingNodeRect) return transform

	const value = { ...transform, y: 0 }
	if (active.data.current.type === 'left') {
		if (draggingNodeRect.left + transform.x <= containerNodeRect.left) {
			value.x = containerNodeRect.left - draggingNodeRect.left
		}
		if (draggingNodeRect.left + transform.x >= containerNodeRect.right) {
			value.x = containerNodeRect.right - draggingNodeRect.left
		}
	}
	if (active.data.current.type === 'right') {
		if (draggingNodeRect.right + transform.x <= containerNodeRect.left) {
			value.x = containerNodeRect.left - draggingNodeRect.left - draggingNodeRect.width
		}
		if (draggingNodeRect.right + transform.x >= containerNodeRect.right) {
			value.x = containerNodeRect.right - draggingNodeRect.left - draggingNodeRect.width
		}
	}
	return value
}

export const dragModifiers: Modifier[] = [
	data => {
		const { active, containerNodeRect, draggingNodeRect, transform, over } = data
		if (!active?.data.current) return transform
		if (!containerNodeRect || !draggingNodeRect) return transform

		if (active.data.current.type === 'new') {
			return getTransformNew(data)
		} else if (['left', 'right'].includes(active.data.current.type)) {
			return getTransformHorizontal(data)
		}

		// prefer dragging vertically without changing time
		if (over?.id !== active.data.current.entry.vehicle_id && Math.abs(transform.x) < 16) {
			return {
				...transform,
				x: 0,
			}
		}

		return transform
	},
]
